<template>
    <div id="IndustryAccount" class="q-pa-md">
        <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
        <div class="row">
            <q-card class="col-12 q-ma-md w98">
                <span v-for="item in industryAccounts" :key="item">
                    <q-card-section v-if="industryAccount === item" class="padding-crud">
                        <crud-layout-search
                            :ref="'crudLayoutSearch-' + item.name"
                            :name="$gettext(item.name)"
                            :interface="item.interface"
                            :id="id"
                            clean-layout
                        />
                    </q-card-section>
                </span>
            </q-card>
        </div>
    </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'IndustryAccount',
  components: { CrudLayoutSearch }
})
class IndustryAccount extends Vue {
    industryAccounts = [];
    industryAccount = '';

    beforeMount () {
      this.industryAccounts = [
        {
          name: 'INDUSTRY_ACCOUNT',
          interface: 'industryAccount.pesquisar'
        }
      ]
      this.industryAccount = this.industryAccounts[0]
    }
}
export default IndustryAccount
</script>

<style lang="stylus" scoped>
#IndustryAccount {
    @import '~quasar-variables';

    .dataTableCrud {
      height: calc(65vh - 25px);
      box-shadow: none !important;
      padding: 0px;
    }

    .buttons-top-crud{
      margin-top: 5px;
      margin-bottom: -3px;
    }
    ::v-deep {
      .jt-crud-container {
        padding: 0%;
      }
    }

    .padding-crud {
      padding: 0px 10px 10px;
      margin-top: -15px;
    }

    .itemSelect {
      color: white;
      background: $secondary !important;
      border-left: 5px solid $dark !important;
      padding-left: 5% !imporant;
    }

    .item {
      background: white;
      font-weight: 500;
      padding-left: 10%;
      font-size: 1rem;
    }
}
.w98 {
  width: 98%;
}
</style>
